import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface VideoOffIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const VideoOffIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick,
}: VideoOffIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 12C15 11.3871 15.3463 10.8269 15.8944 10.5528L19.5528 8.72362C20.2177 8.39117 21 8.87466 21 9.61804V14.382C21 15.1253 20.2177 15.6088 19.5528 15.2764L15.8944 13.4472C15.3463 13.1731 15 12.6129 15 12Z"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M11 6H5C3.89543 6 3 6.89543 3 8V16M10 18H13C14.1046 18 15 17.1046 15 16V12"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M16.5 4.49999L4.00001 20"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    )
}

export default VideoOffIcon
